import type { Store } from "redux";

import type { RootState } from "./rootReducer";

let storeRef: null | Store<RootState> = null;

export const setStoreRef = (store: Store<RootState>): void => {
  storeRef = store;
};

export const getStoreState = (): RootState => {
  if (!storeRef) {
    throw new Error("Redux store has not been initialized");
  }
  return storeRef.getState();
};
